
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  function formatDate (input) {
  var datePart = input.match(/\d+/g),
  year = datePart[0], // get only two digits
  month = datePart[1], 
  day = datePart[2];

  return day+'-'+month+'-'+year;
}

  Flits(document).on('Flits:myProfile:Loaded',function(event){
    let date = Flits('#flits-form-profile .flits-input[name="birthdate"]').val();
    if(!Flits.isNull(date)){ 
      let formattedDate = formatDate(date);
      Flits('#flits-form-profile .flits-input[name="birthdate"]').attr("orignal-date",date)
      Flits('#flits-form-profile .flits-input[name="birthdate"]').val(formattedDate)
    }
  });
Flits(document).on('Flits:myProfile:EditButtonClicked',function(event){
     let origanlDate = Flits('#flits-form-profile .flits-input[name="birthdate"]').attr("orignal-date")
    if(!Flits.isNull(origanlDate)){   
      let formattedDate = formatDate(origanlDate);
      Flits('#flits-form-profile .flits-input[name="birthdate"]').attr("formatted-date",formattedDate);
      Flits('#flits-form-profile .flits-input[name="birthdate"]').val(origanlDate)
    }
  });

  Flits(document).on('Flits:myProfile:EditCancelButtonClicked Flits:myProfile:Updated',function(event){
     let origanlDate = Flits('#flits-form-profile .flits-input[name="birthdate"]').parent().parent().attr("data-flits-birthdate")
    if(!Flits.isNull(origanlDate)){   
      let formattedDate = formatDate(origanlDate);
      Flits('#flits-form-profile .flits-input[name="birthdate"]').attr("orignal-date",origanlDate)
      Flits('#flits-form-profile .flits-input[name="birthdate"]').attr("formatted-date",formattedDate);
      Flits('#flits-form-profile .flits-input[name="birthdate"]').val(formattedDate)
    }
  });
  
  // Flits(document).on('Flits:myProfile:Loaded',function(event){
  //   let date = Flits('#flits-form-profile .flits-input[name="birthdate"]').val();
  //   var dateAr = date.split('-');
  //   var newDate = dateAr[2] + '-' + dateAr[1] + '-' + dateAr[0];
  //   Flits('#flits-form-profile .flits-input[name="birthdate"]').val(newDate);
  // });
  // Flits(document).on('Flits:myProfile:Updated',function(event){
  //   let date = Flits('#flits-form-profile .flits-input[name="birthdate"]').val();
  //   var dateAr = date.split('-');
  //   var newDate = dateAr[2] + '-' + dateAr[1] + '-' + dateAr[0];
  //   Flits('#flits-form-profile .flits-input[name="birthdate"]').val(newDate);
  // });
}(Flits));
